const $ = window.jQuery; 

const archiveFilter = {
    options: {
        class: {
            ajaxContainer: 'ajax-loading-container',
            filtersContainer: 'post-list-filters',
            postsContainer: 'post-list-posts',
            postsCounter: 'post-count',
        },
        id: {
            orderbySelect: 'orderby',
            orderSelect: 'order'
        }
    },

    init: function() {
        const self = this;

        self.initActions();
    },

    initActions: function() {
        const   self            = this,
                filterContainer = document.querySelector('.' + self.options.class.filtersContainer),
                filters         = filterContainer.querySelectorAll('a'),
                orderbySelect   = document.getElementById(self.options.id.orderbySelect),
                orderSelect   = document.getElementById(self.options.id.orderSelect);
        
        filters.forEach( filter => {
            filter.addEventListener( 'click', function(e) {
                e.preventDefault();
                self.updateQueryParams(e.target);
                self.ajaxClickHandlerFilterCats(e.target.dataset.category);
                self.updateFilterClasses(e.target);
            })
        })

        orderbySelect.addEventListener( 'change', function(e) {
            e.preventDefault();

            // check query param for category filter
            var searchParams = new URLSearchParams(window.location.search);
            var catId = searchParams.get('category');
            // load articles with new orderby param
            self.ajaxClickHandlerFilterCats(catId);

            searchParams.set('orderby', e.target.value);
            // Add the URL to history - does not refresh the page
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        });

        orderSelect.addEventListener( 'change', function(e) {
            e.preventDefault();

            // check query param for category filter
            var searchParams = new URLSearchParams(window.location.search);
            var catId = searchParams.get('category');
            // load articles with new orderby param
            self.ajaxClickHandlerFilterCats(catId);

            searchParams.set('order', e.target.value);
            // Add the URL to history - does not refresh the page
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        });
    },

    getOrderValue: function() {
        var self            = this,
            orderSelect   = document.getElementById(self.options.id.orderSelect);

        return orderSelect.value;
    },

    getOrderbyValue: function() {
        var self            = this,
            orderbySelect   = document.getElementById(self.options.id.orderbySelect);

        return orderbySelect.value;
    },

    updateFilterClasses: function(elem) {
        const   self              = this,
                filterContainer   = document.querySelector('.' + self.options.class.filtersContainer);

        filterContainer.querySelectorAll('a').forEach( filter => {
            filter.classList.remove('bg-transparent');
            filter.classList.remove('text-white')
            filter.classList.add('bg-white');
            filter.classList.add('text-grey')
        })

        elem.classList.add('bg-transparent')
        elem.classList.add('text-white')
        elem.classList.remove('bg-white')
        elem.classList.remove('text-grey')
    },

    ajaxClickHandlerFilterCats: function(catId) {
        const   self            = this,
                ajaxContainer   = document.querySelector('.' + self.options.class.ajaxContainer),
                postsContainer  = document.querySelector('.' + self.options.class.postsContainer),
                postsCounter    = document.querySelector('.' + self.options.class.postsCounter),
                filterContainer = document.querySelector('.' + self.options.class.filtersContainer),
                catPrimary      = filterContainer.dataset.catPrimary || '',
                nonce           = filterContainer.dataset.nonce,
                catIds          = [catPrimary];

        if( catId ) 
            catIds.push( catId );

        let data = {
            action: 'filter_posts',
            nonce: nonce,
            category: catIds,
            postsperpage: 12,
            orderby: self.getOrderbyValue(),
            order: self.getOrderValue(),
        }

        $.ajax({
            url: emc_ajax.ajaxurl,
            data: data,
            dataType: 'JSON',
            method: 'POST',
            beforeSend: function( xhr ) {
                // let the user know the site is at work
                ajaxContainer.classList.remove('hidden')
            },
            success: function( data ) {
                // remove the loading icon
                ajaxContainer.classList.add('hidden')

                // append returned HTML data to resources lists
                postsContainer.innerHTML = data.html;

                // update the total articles
                postsCounter.querySelector('span').innerHTML = data.found_posts;

                // create and dispatch posts refreshed event
                // pass the max num of pages value through to the event
                var eventPostsRefreshed =  new CustomEvent('postsRefreshed', {detail:  { maxNumPages: data.max_num_pages }});
                window.dispatchEvent( eventPostsRefreshed );
            }                
        })
    },

    /**
     * Set the new window location using the elems data attributes
     * Useful when users share URLs
     * E.g. test.com?foo=bar
     * 
     * @param {object} elem 
     */
    updateQueryParams: function(elem) {
        const self = this;
        // Get data params from clicked element
        const data = elem.dataset;

        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search)

            // Loop over each node in the dataset and set the value
            for (const [key, value] of Object.entries(data)) {
                searchParams.set(self.formatQueryParam(key), value);
            }
            
            // Add the URL to history - does not refresh the page
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }

    },

    /**
     * Corrects the format of a dataset object key
     * E.g. turns catId into cat_id
     * 
     * @param {string} key 
     * @returns 
     */
    formatQueryParam: function(key) {
        var regex = /([A-Z])/g;
        var formattedKey = key.replace(regex, function(match) {
            return '_' + match.toLowerCase();
        });

        return formattedKey;
    }
}

// run the widget
archiveFilter.init();